/* somnair-bk.js — comportements de la famille « Back / relief » (classes smbk-).
 *
 * Volontairement SANS logique d'ajout au panier : le formulaire de somnair-bk-main porte
 * la classe `smp-atcform`, déjà écoutée en délégation par assets/somnair-atc.js (POST AJAX
 * -> cart-drawer.renderContents + retrait du `is-empty` resté collé sur l'hôte). On
 * réutilise ce fichier tel quel plutôt que de le modifier : c'est du niveau (a).
 *
 * ⚠️ Tout élément qui doit apparaître/disparaître (barre sticky, commentaires repliés)
 * DOIT porter l'attribut data-smsl-anim. Sans lui, la règle force-visible héritée de
 * somnair-sl.css (`.smbk-scope *:not([data-smsl-anim]){opacity:1!important;
 * visibility:visible!important}`) gagne et l'élément est visible dès le pixel 0.
 */
(function () {
  'use strict';

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  /* ---------------------------------------------------------------- galerie */
  function initGallery(root) {
    var track = root.querySelector('[data-bk-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-bk-slide]');
    var thumbs = root.querySelectorAll('[data-bk-thumb]');
    var dots = root.querySelectorAll('[data-bk-dot]');
    if (!slides.length) return;

    function goTo(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    function setActive(index) {
      each(thumbs, function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      each(dots, function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      // Une vidéo qui sort du cadre est mise en pause : sinon le son continue hors écran.
      each(slides, function (s, i) {
        var video = s.querySelector('video');
        if (video && i !== index && !video.paused) video.pause();
      });
    }

    each(thumbs, function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i, false); setActive(i); });
    });
    each(dots, function (dot, i) {
      dot.addEventListener('click', function () { goTo(i, true); setActive(i); });
    });

    // Synchro swipe -> vignettes/points, via rAF pour ne pas saturer le thread de scroll.
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        each(slides, function (s, i) {
          var center = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
          var dist = Math.abs(center - mid);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        setActive(best);
      });
    }, { passive: true });

    // Warm-up : la 1re interaction passe les images restantes de lazy à eager, pour que
    // le swipe ne tombe pas sur des cases vides.
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      each(track.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    }
    track.addEventListener('scroll', warm, { once: true, passive: true });
    track.addEventListener('pointerdown', warm, { once: true });

    setActive(0);
  }

  /* -------------------------------------------------------------- quantité */
  function initQty(root) {
    each(root.querySelectorAll('[data-bk-qty]'), function (wrap) {
      var input = wrap.querySelector('input[name="quantity"]');
      if (!input) return;
      each(wrap.querySelectorAll('[data-bk-qty-step]'), function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-bk-qty-step'), 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          var max = parseInt(input.max, 10) || 99;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.min(max, Math.max(min, next));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------ barre CTA sticky */
  function initSticky(bar) {
    var after = parseInt(bar.getAttribute('data-bk-after'), 10) || 600;
    var mobileOnly = bar.getAttribute('data-bk-mobile-only') === 'true';

    function update() {
      if (mobileOnly && window.innerWidth > 749) { bar.hidden = true; return; }
      bar.hidden = window.scrollY < after;
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ------------------------------------------------- fil de commentaires */
  function initComments(root) {
    var button = root.querySelector('[data-bk-more]');
    if (!button) return;
    var hiddenItems = root.querySelectorAll('[data-bk-comment][data-smsl-anim][hidden]');
    if (!hiddenItems.length) { button.hidden = true; return; }
    button.addEventListener('click', function () {
      each(hiddenItems, function (item) { item.hidden = false; });
      button.hidden = true;
    });
  }

  /* ------------------------------------------------ date du bandeau promo */
  /* Toujours en JS : Shopify sert des pages en cache, `{{ 'now' | date }}` gèlerait à la
     date du rendu. Même raison que la nav tunnel de header.liquid. */
  function initDate(root) {
    each(root.querySelectorAll('[data-bk-date]'), function (node) {
      var style = node.getAttribute('data-bk-date') || 'long';
      var opts = style === 'short'
        ? { month: 'short', day: 'numeric' }
        : style === 'weekday_long'
          ? { weekday: 'long', month: 'long', day: 'numeric' }
          : { month: 'long', day: 'numeric', year: 'numeric' };
      try {
        node.textContent = new Intl.DateTimeFormat('en-US', opts).format(new Date());
      } catch (e) { /* laisse le repli écrit en Liquid */ }
    });
  }

  /* ------------------------------------------------------------- amorçage */
  function boot(scope) {
    each((scope || document).querySelectorAll('.smbk-scope'), function (root) {
      if (root.dataset.bkReady === '1') return;
      root.dataset.bkReady = '1';
      initGallery(root);
      initQty(root);
      initComments(root);
      initDate(root);
      if (root.classList.contains('smbk-sticky')) initSticky(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  // Le theme editor réinjecte une section sans recharger la page.
  document.addEventListener('shopify:section:load', function (evt) { boot(evt.target); });
})();
